import { CreateUser, UserConditions } from '@shared/types/pip';
import { FormikProps } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Checkbox from '../Checkbox/Checkbox';
import { useSelector } from 'react-redux';
import styles from './ConsentCheckbox.module.css';
import { FormState } from '@features/Auth/components/AuthenticationForm/AuthenticationForm';
import { RootState } from '@shared/store';
const { Container } = styles;

interface ConsentCheckboxProps {
  formik: FormikProps<CreateUser> | FormikProps<FormState>;
  isCheckout?: boolean;
}

const ConsentCheckbox = ({ formik, isCheckout }: ConsentCheckboxProps) => {
  const {
    options: {
      termsText,
      termsMembershipInfoText,
      termsAcceptText,
      consentAcceptText,
    },
  } = useSelector((state: RootState) => state.wordpress);

  const handleAcceptance = ({
    termsOfUse,
    marketingConsent,
  }: UserConditions) => {
    formik.setFieldValue('conditions', {
      termsOfUse: termsOfUse,
      marketingConsent: marketingConsent,
    });
  };

  const isCheckedIcon = (isChecked: boolean | undefined) =>
    isChecked ? <FontAwesomeIcon icon={faCheck} size="1x" /> : null;

  const hasError =
    (formik.touched.conditions?.termsOfUse &&
      !formik.values.conditions.termsOfUse) ||
    false;

  const termsAcceptanceLabel = isCheckout
    ? `${termsText} ${termsMembershipInfoText}`
    : termsAcceptText;

  return (
    <div className={Container}>
      <Checkbox
        label={termsAcceptanceLabel}
        isChecked={formik.values.conditions.termsOfUse || false}
        hasError={hasError}
        handleClick={() =>
          handleAcceptance({
            termsOfUse: !formik.values.conditions.termsOfUse,
            marketingConsent: formik.values.conditions.marketingConsent,
          })
        }
        icon={isCheckedIcon(formik.values.conditions.termsOfUse)}
        spacing
      />

      <Checkbox
        label={consentAcceptText}
        isChecked={formik.values.conditions.marketingConsent || false}
        handleClick={() =>
          handleAcceptance({
            termsOfUse: formik.values.conditions.termsOfUse,
            marketingConsent: !formik.values.conditions.marketingConsent,
          })
        }
        icon={isCheckedIcon(formik.values.conditions.marketingConsent)}
        spacing
      />
    </div>
  );
};

export default ConsentCheckbox;
